var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureStreamtopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38034 2.5L4.28633 4.28633L2.5 7.38034V10.953L4.28633 14.047L7.38034 15.8333H10.953L14.047 14.047L15.8333 10.953V7.38034L14.047 4.28633L10.953 2.5H7.38034ZM7.22952 1.93714L9.16667 0L11.1038 1.93714L13.75 1.2281L14.459 3.87429L17.1052 4.58333L16.3962 7.22952L18.3333 9.16667L16.3962 11.1038L17.1052 13.75L14.459 14.459L13.75 17.1052L11.1038 16.3962L9.16667 18.3333L7.22952 16.3962L4.58333 17.1052L3.87429 14.459L1.2281 13.75L1.93714 11.1038L0 9.16667L1.93714 7.22952L1.2281 4.58333L3.87429 3.87429L4.58333 1.2281L7.22952 1.93714Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 10.8232L7.20738 11.8634L7.59124 9.67856L5.99648 8.13662L8.193 7.82654L9.16667 5.83334L10.1403 7.82654L12.3369 8.13662L10.7421 9.67856L11.126 11.8634L9.16667 10.8232Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureStreamtopIcon);
export default __webpack_public_path__ + "static/media/feature_streamtop_icon.aab6ab5d2f6aa11cafd8975596b8336d.svg";
export { ForwardRef as ReactComponent };